interface ResultsIntroProps {
  onContinue: () => void;
  onBack?: () => void;
}

export function ResultsIntro({ onContinue, onBack }: ResultsIntroProps) {
  return (
    <section className="bloom-questions-intro bloom-scenario-intro" aria-label="Uitleg voor je tuin">
      <div className="bloom-questions-intro__card">
        <h2 className="bloom-questions-intro__title">Jouw persoonlijke ACT-tuin</h2>

        <div className="bloom-questions-intro__body">
          <p>
            Een tuin krijgt te maken met allerlei soorten weer. Soms schijnt de zon, maar er kunnen
            ook harde wind, regenbuien, onweer of vervelende beestjes komen. Een tuin met stevige
            planten, sterke wortels en verschillende soorten begroeiing kan zulke tegenslagen
            meestal beter aan. In een tuin die nog weinig begroeiing heeft, kunnen planten sneller
            omwaaien of uitdrogen. Dat betekent niet dat er iets mis is met die tuin: sommige delen
            hebben gewoon nog wat extra aandacht nodig.
          </p>
          <p>
            Alle onderdelen van een tuin hebben invloed op elkaar. Een boom kan bijvoorbeeld
            schaduw geven aan bloemen, planten kunnen de grond beschermen tegen uitdroging en bijen
            helpen bloemen om verder te groeien. Zo werken de onderdelen van ACT ook samen. Wanneer
            je gevoelens kunt toelaten, wat afstand kunt nemen van je gedachten, aandacht hebt voor
            wat er nu gebeurt, vriendelijk naar jezelf kunt kijken, weet wat belangrijk voor je is
            en daar actie op onderneemt, kun je beter omgaan met lastige momenten en tegenslagen.
          </p>
          <p>
            Straks zie je hoe jouw tuin er op dit moment uitziet. Jouw tuin vertelt niet of je iets
            goed of fout doet. Hij laat zien welke onderdelen al stevig groeien en welke onderdelen
            misschien wat extra verzorging kunnen gebruiken. Zo weten jij en je behandelaar waar
            jullie samen mee aan de slag kunnen. Want alles wat je aandacht geeft, kan groeien.
          </p>
        </div>

        <div className="bloom-questions-intro__actions">
          {onBack ? (
            <button type="button" className="bloom-btn bloom-btn--ghost" onClick={onBack}>
              Terug
            </button>
          ) : (
            <span />
          )}
          <button
            type="button"
            className="bloom-btn bloom-btn--primary bloom-questions-intro__start"
            onClick={onContinue}
          >
            Verder
          </button>
        </div>
      </div>
    </section>
  );
}
